import React from 'react';
import { Box, keyframes } from '@chakra-ui/react';

const floatAnimation = keyframes`
  0% { transform: translateY(0px) rotate(0deg); opacity: 0.8; }
  50% { transform: translateY(-20px) rotate(5deg); opacity: 0.4; }
  100% { transform: translateY(0px) rotate(0deg); opacity: 0.8; }
`;

const pulseAnimation = keyframes`
  0% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.1); opacity: 0.5; }
  100% { transform: scale(1); opacity: 0.3; }
`;

const BackgroundEffects = () => {
  return (
    <>
      {/* Main background gradient */}
      <Box
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="black"
        zIndex="-2"
        backgroundImage="radial-gradient(circle at 10% 20%, rgba(0, 210, 255, 0.1) 0%, transparent 40%), radial-gradient(circle at 90% 80%, rgba(255, 0, 255, 0.1) 0%, transparent 40%)"
      />
      
      {/* Grid overlay */}
      <Box
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        opacity="0.05"
        zIndex="-1"
        pointerEvents="none"
        backgroundImage="linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px), linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)"
        backgroundSize="80px 80px"
        backgroundPosition="center center"
      />
      
      {/* Floating orb 1 - Cyan */}
      <Box
        position="fixed"
        top="20%"
        left="10%"
        width="300px"
        height="300px"
        borderRadius="full"
        bg="rgba(0, 210, 255, 0.1)"
        filter="blur(80px)"
        zIndex="-1"
        animation={`${floatAnimation} 15s infinite ease-in-out`}
      />
      
      {/* Floating orb 2 - Purple */}
      <Box
        position="fixed"
        bottom="10%"
        right="15%"
        width="250px"
        height="250px"
        borderRadius="full"
        bg="rgba(255, 0, 255, 0.1)"
        filter="blur(80px)"
        zIndex="-1"
        animation={`${floatAnimation} 18s infinite ease-in-out 2s`}
      />
      
      {/* Floating orb 3 - Blue */}
      <Box
        position="fixed"
        top="60%"
        left="60%"
        width="200px"
        height="200px"
        borderRadius="full"
        bg="rgba(0, 100, 255, 0.1)"
        filter="blur(60px)"
        zIndex="-1"
        animation={`${floatAnimation} 20s infinite ease-in-out 1s`}
      />
      
      {/* Pulsing center glow */}
      <Box
        position="fixed"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="500px"
        height="500px"
        borderRadius="full"
        bg="rgba(100, 100, 255, 0.05)"
        filter="blur(100px)"
        zIndex="-1"
        animation={`${pulseAnimation} 10s infinite ease-in-out`}
      />
      
      {/* Noise texture overlay */}
      <Box
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        opacity="0.03"
        zIndex="-1"
        pointerEvents="none"
        backgroundImage="url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIGJhc2VGcmVxdWVuY3k9Ii43NSIgc3RpdGNoVGlsZXM9InN0aXRjaCIgdHlwZT0iZnJhY3RhbE5vaXNlIi8+PGZlQ29sb3JNYXRyaXggdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPjwvZmlsdGVyPjxwYXRoIGQ9Ik0wIDBoMzAwdjMwMEgweiIgZmlsdGVyPSJ1cmwoI2EpIiBvcGFjaXR5PSIuMDUiLz48L3N2Zz4=')"
      />
    </>
  );
};

export default BackgroundEffects;